import { createSelector } from 'reselect'

const select = state => state.bulletin

const selectMessages = createSelector(select, bulletin => bulletin.messages)

const selectIsFetching = createSelector(select, bulletin => bulletin.isFetching)

const selectTotalCount = createSelector(select, bulletin => bulletin.totalCount)

const selectPage = createSelector(select, bulletin => bulletin.page)

export { selectMessages, selectIsFetching, selectTotalCount, selectPage }
